import React from 'react';
import {Col, Row, Container } from 'react-bootstrap';
import Image from 'react-bootstrap/Image';
import { useNavigate } from 'react-router-dom';

function Ourspecialites() {
  const navigate = useNavigate()
  const captionStyleheader = {
    textAlign: 'center',
    padding: '2px',
  };

  const captionStyle = {
    textAlign: 'center',
    padding: '2px',
    // backgroundColor: '#F7F9FF',
    marginBottom: '10px',
    boxShadow: '0px 8px 16px rgba(0, 0, 0, 0.1)', // Increase the box shadow
    borderRadius: '10px',
    border: 'none', // Remove the border
  };

  const captionStyleBottom = {
    textAlign: 'center',
    padding: '2px',
    // backgroundColor: '#F7F9FF',
    marginBottom: '90px',
    boxShadow: '0px 8px 16px rgba(0, 0, 0, 0.1)', // Increase the box shadow
    borderRadius: '10px',
    border: 'none', // Remove the border
  };

  const captionTextStyle = {
    fontSize: '2rem',
    // fontWeight: 'bold',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    color: '#2855A1',
    marginTop: '2rem',
  };

  const captionTextStyle2 = {
    fontSize: '2rem',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    color: 'black',
  };

  const captionTextStyleCard = {
    fontSize: '1.2rem',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    marginTop: '2rem',
    marginBottom: '30px',
  };

  const imageStyle = {
    marginBottom: '10px',
    marginTop: '10px',
    width: '204px', // Adjust the width as needed
    height: '200px', // Adjust the height as needed
    objectFit: 'cover', // Preserve aspect ratio and cover the container
    // filter: 'opacity(3) brightness(1)',
  };

  const handleTitleClick = () => {
    // Navigate to another page when the title is clicked
    navigate('/About');
  };

  return (
    <Container 
    fluid
      style={{
        // backgroundColor: '#F7F9FF',
        marginBottom: '10px',
        height: 'auto', // Adjusted to 'auto' for responsive height
        marginTop: '10px',
      }}
    >
      <div style={{ padding: '2px', marginTop: '50px' }}>
        <div style={captionStyleheader} >
          <h3 style={captionTextStyle}>
            <span style={captionTextStyle2}>Our</span> Specialities
          </h3>
        </div>
      </div>

      <div style={{ padding: '2px', marginTop: '50px' }}>
        {/* First Row */}
        <Row className="justify-content-center">
          <Col xs={12} md={6} lg={4}>
            <div className="card" style={captionStyle}>
              <div className="card-body">
                <Image src={process.env.PUBLIC_URL + '/assets/images/Group1.png'} alt="" style={imageStyle} className='animated-imaget' />
                <h5 className="card-title" style={captionTextStyleCard} onClick={handleTitleClick}>
                  Emirati / Saudi Talent Acquisition
                </h5>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={4}>
            <div className="card" style={captionStyle}>
              <div className="card-body">
                <Image src={process.env.PUBLIC_URL + '/assets/images/Group2.png'} alt="" style={imageStyle} className='animated-imaget'/>
                <h5 className="card-title" style={captionTextStyleCard} onClick={handleTitleClick}>
                  Skilled Talent Acquisition
                </h5>
              </div>
            </div>
          </Col>
        </Row>

        {/* Second Row */}
        <Row className="justify-content-center" style={{ marginTop: '10px' }}>
          <Col xs={12} md={6} lg={4}>
            <div className="card" style={captionStyle}>
              <div className="card-body">
                <Image src={process.env.PUBLIC_URL + '/assets/images/Group3.png'} alt="" style={imageStyle} className='animated-imaget' />
                <h5 className="card-title" style={captionTextStyleCard} onClick={handleTitleClick}>
                  Talent Training and Development
                </h5>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={4}>
            <div className="card" style={captionStyleBottom}>
              <div className="card-body">
                <Image src={process.env.PUBLIC_URL + '/assets/images/Group4.png'} alt="" style={imageStyle} className='animated-imaget' />
                <h5 className="card-title" style={captionTextStyleCard} onClick={handleTitleClick}>
                  Executive Search
                </h5>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </Container>
  );
}

export default Ourspecialites;
